import store from '../store';
import { homeGuard } from './homeGuard';

export async function authenticate(to, from, next) {
  if (to.name === 'login') {
    if (store.getters['auth/isLoggedIn']) {
      homeGuard(to, from, next);
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters['auth/isLoggedIn']) {
      next({ name: 'login', query: { redirect: to.path } });
    } else {
      // Check role-based access
      const rolesRequired = to.meta.rolesRequired;
      if (rolesRequired && rolesRequired.length) {
        const user = store.getters['auth/getLoggedInUser'];
        if (user && rolesRequired.includes(user.role)) {
          next();
        } else {
          homeGuard(to, from, next);
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
}
